import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './instructions.module.scss';

const cx = classnames.bind(styles);

function Instructions({ title, desc, leftAlign, mTitle, mDesc, maxWidth }) {
  return (
    <div className={cx({ container: 1, left: leftAlign })}>
      <div className={styles.inner}>
        {title && <h2>{title}</h2>}
        {desc && <h4 style={{ maxWidth }}>{desc}</h4>}
      </div>
      <div className={styles.mobile}>
        {mTitle && mDesc && (
          <>
            <h2>{mTitle}</h2>
            <h4>{mDesc}</h4>
          </>
        )}
        {mTitle && !mDesc && <h3>{mTitle}</h3>}
        {mDesc && !mTitle && <h5>{mDesc}</h5>}
      </div>
    </div>
  );
}

Instructions.propTypes = {
  desc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  leftAlign: PropTypes.bool,
  maxWidth: PropTypes.number.isRequired,
  mDesc: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  mTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

Instructions.defaultProps = {
  maxWidth: 525,
};

export default Instructions;
